import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { InsignModuleRoutes } from '@app/modules/insign-confirm/insign-routes';
import { InsignStartComponent } from '@app/modules/insign-confirm/pages/insign-start/insign-start.component';
import { InsignFinishComponent } from '@app/modules/insign-confirm/pages/insign-finish/insign-finish.component';

export const routes: Routes = [
    { path: InsignModuleRoutes.INSIGN_START, component: InsignStartComponent, data: { hideToolbar: true, pageTitle: 'inSign' } },
    { path: InsignModuleRoutes.INSIGN_FINISH, component: InsignFinishComponent, data: { hideToolbar: true, pageTitle: 'inSign' } }
];

export const routing = RouterModule.forChild(routes);

@NgModule({
    imports: [routing],
    exports: [RouterModule]
})
export class InsignRoutingModule {}
